/** Server-side listing search page size (home and listing feeds). */
export const LISTINGS_PAGE_SIZE = 24;
